export const readList = (data) => {
  if (Array.isArray(data)) {
    return { items: data, totalCount: data.length };
  }

  const items = data?.items ?? data?.Items ?? data?.item1 ?? data?.Item1 ?? [];
  const total = data?.totalCount ?? data?.TotalCount ?? data?.total ?? data?.Total ?? data?.item2 ?? data?.Item2;
  return {
    items: Array.isArray(items) ? items : [],
    totalCount: Number(total ?? (Array.isArray(items) ? items.length : 0)) || 0,
  };
};

export const readNumber = (value) => {
  if (value == null || value === '') {
    return null;
  }

  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : null;
};
